
import BolliniVerdiActions from "../bolliniVerdi/BolliniVerdiActions";
import { action } from "../common/Action";
import { AggiornaDateControlloData, ApparecchioFamily, ExpirationSettingsDto } from "../generated";
import type { ApparecchioCategory, IExpirationSettingsDto } from "../generated";
import InterventiActions from "../interventi/InterventiActions";
import { service, settingsService } from "./ExpirationsActions";
import ImpiantiActions from "../impianti/ImpiantiTermiciActions";
import type { Dictionary } from "../common/AbstractStores";
import { uniq } from "lodash";
import ImpiantiClienteActions from "../impianti/ImpiantiClienteActions";

export class ExpirationsActions {

    @action
    async getExpirations(from: Date, to: Date, showPrevYears: boolean) {
        var expirations = await service.getScadenze(from, to, showPrevYears);
        return { from, to, expirations, showPrevYears };
    }

    @action
    async evadiScadenzeMassivo(input: { IdImpianto: number; IdCliente: number; }[], data: AggiornaDateControlloData, categories: Dictionary<ApparecchioCategory>) {
        const idImpianti = input.map(x => x.IdImpianto);
        await service.evasioneScadenzeMassivo(idImpianti, data);
        if (data.bollinoChecked) {
            for (const idImpianto of idImpianti)
                BolliniVerdiActions.getByImpianto(idImpianto);
        }
        for (const idCliente of uniq(input.map(x => x.IdCliente))) {
            const impiantiCliente = await ImpiantiClienteActions.getForCustomer(idCliente);
            InterventiActions.getByCustomer(idCliente);
            for (const impianto of impiantiCliente.impianti!.filter(x => categories[x.type]?.family == ApparecchioFamily.Idrotermico)) {
                ImpiantiActions.getImpiantoTermico(impianto.id);
            }
        }
    }
    @action
    getCurrent() {
        return settingsService.getCurrent();
    }

    @action
    async save(settings: IExpirationSettingsDto) {
        await settingsService.save(new ExpirationSettingsDto(settings));
        return this.getCurrent();
    }
}
